import { useSupported } from '@vueuse/core';

export function useWebotp() {
  const code = ref('');
  const isMobile = /iphone|android/i.test(navigator.userAgent);
  const isAbortControllerSupported = useSupported(() => 'AbortController' in window);
  const isOTPCredentialSupported = useSupported(() => 'OTPCredential' in window);
  const isCompatible = isMobile && isAbortControllerSupported.value && isOTPCredentialSupported.value;

  let controller: AbortController | null = null;

  controller = new AbortController();

  const webOtpError = 'Abort webotp';

  function abort() {
    if (isCompatible) controller?.abort(webOtpError);
  }

  if (isCompatible) {
    const options = {
      otp: { transport: ['sms'] },
      signal: controller.signal,
    };

    navigator.credentials.get(options).then((otp) => {
      // @ts-expect-error "code" does not exist on type "Credential"
      const { code: otpCode } = otp;

      code.value = otpCode;
    }).catch((err) => {
      if (err === webOtpError) {
        return;
      }

      throw err;
    });
  }

  return {
    code,
    abort,
    isCompatible,
  };
}
